import axios from "axios";
import { API_BASE } from "../../config/env";
export const FETCH_STARTAPPLICATIONV2_FULFILLED = "FETCH_STARTAPPLICATIONV2_FULFILLED";
export const FETCH_STARTAPPLICATIONV2_REJECTED = "FETCH_STARTAPPLICATIONV2_REJECTED";
export const FETCH_STARTAPPLICATIONV2_PENDING = "FETCH_STARTAPPLICATIONV2_PENDING";
export const RESET_STARTAPPLICATIONV2 = "RESET_STARTAPPLICATIONV2"

/** 
 {
  "careProviderData": {
    "careProviderId": "string",
    "facilityId": "string",
    "facilityName": "string",
    "fullName": "string",
    "identityNumber": "string",
    "name": "string",
    "surname": "string",
    "phoneNumber": "string",
    "username": "string",
    "email": "string",
    "doctorRegistrationNumber": "string",
    "saglikNetCode": "string",
    "saglikNetPassword": "string",
    "saglikNetClinicCode": "string",
    "saglikNetClinicName": "string",
    "professionId": "string",
    "professionCode": "string",
    "professionName": "string",
    "password": "string",
    "title": "string",
    "tags": "string",
    "bio": "string",
    "workDays": "string",
    "workHours": "string",
    "slotInterval": 0,
    "earliestAvailability": "2024-01-31T19:17:33.220Z",
    "gender": 1,
    "onlineAvailability": true,
    "imageUrl": "string",
    "cv": "string",
    "userId": "3fa85f64-5717-4562-b3fc-2c963f66afa6"
  },
  "surveyData": {
    "surveyName": "string",
    "data": "string",
    "pdfData": "string"
  }
*/

export function startApplicationv2(careProviderData, surveyData, targetInstitution,representedPatientInformation) {
    const token = localStorage.getItem("accessToken")

    return (dispatch) => {
        dispatch({
            type: "FETCH_STARTAPPLICATIONV2",
            payload: axios({
                method: "post",
                url: `${API_BASE}/api/v3/second-opinion/start-application`,
                data: { careProviderData, surveyData, targetInstitution,representedPatientInformation },
                headers: {
                    "Authorization": "Bearer " + token,
                    "Accept-Language": "tr-tr",
                    "Client-Id": localStorage.getItem("One-Id"),
                    "One-Id": localStorage.getItem("Client-Id"),
                    "Content-Type": "application/json",
                    "ngrok-skip-browser-warning": "69920"
                },
            }).then((result) => result.data),
        });
    };
}

export function resetStartApplicationv2() {
    return (dispatch) => {
        dispatch({
            type: "RESET_STARTAPPLICATIONV2",
        });
    };
}




